import get from "lodash/get"
import { currentCompany } from "../../../constants"

const styles = (theme) => {
    let linkWidth = {
        paddingLeft: "16px"
    }
    let simpleLink = {
        color: "inherit",
        display: "inline-block",
    }

    let flex = {
        flex: "1",
        flexGrow: 1,
        flexShrink: 0,
        flexBasis: "auto",
    }

    let loginBottom = {
        display: "flex",
        justifyContent: "flex-start",
        [theme.breakpoints.down("md")]: {
            justifyContent: "center",
        },
        padding: "0 40px",
        height: 56,
    }

    let createAccountButton = {
        textAlign: "center",
        color: "inherit",
        textDecoration: "none",
    }

    if (currentCompany === "capgemini") {
        linkWidth = {
            color: get(theme, "appicalTheme.black"),
        }
        createAccountButton = {
            ...createAccountButton,
            color: get(theme, "appicalTheme.black"),
        }
        simpleLink = {
            textDecoration: "none",
            color: get(theme, "appicalTheme.black"),
            display: "flex",
            flexDirection: "row-reverse",
            textDecoration: "underline",
            [theme.breakpoints.down("md")]: {
                flexDirection: "row",
                justifyContent: "center",
                marginTop: 8,
            },
        }
        flex = {
            ...flex,
            [theme.breakpoints.down("md")]: {
                flex: "0.5",
                flexGrow: 0.5,
            },
        }
        loginBottom = {
            ...loginBottom,
            [theme.breakpoints.down("md")]: {
                height: 80,
            },
        }
    }
    if (currentCompany === "heineken") {
        simpleLink = {
            ...simpleLink,
            color: get(theme, "appicalTheme.loginBgText"),
            textDecoration: "underline",
            display: "flex",
            flexDirection: "row-reverse",
            fontWeight: "bold",
            [theme.breakpoints.down("md")]: {
                flexDirection: "row",
                justifyContent: "center",
                marginTop: 8,
            },
        }
        createAccountButton = {
            ...createAccountButton,
            color: get(theme, "appicalTheme.loginBgText"),
        }
        linkWidth = {
            ...linkWidth,
            color: get(theme, "appicalTheme.loginBgText"),
        }
    }

    if (currentCompany === "arkin") {
        simpleLink = {
            ...simpleLink,
            color: get(theme, "appicalTheme.loginBgText"),
            textDecoration: "underline",
            display: "flex",
            flexDirection: "row-reverse",
            fontWeight: "bold",
            [theme.breakpoints.down("md")]: {
                flexDirection: "row",
                justifyContent: "center",
                marginTop: 8,
            },
        }
        createAccountButton = {
            ...createAccountButton,
            color: get(theme, "appicalTheme.loginBgText"),
        }
        linkWidth = {
            ...linkWidth,
            color: get(theme, "appicalTheme.loginBgText"),
        }
    }
    if (currentCompany === "allianzgi") {
        simpleLink = {
            ...simpleLink,
            color: get(theme, "appicalTheme.contrastText"),
            textDecoration: "underline",
            display: "flex",
            flexDirection: "row-reverse",
            fontWeight: "bold",
            [theme.breakpoints.down("md")]: {
                flexDirection: "row",
                justifyContent: "center",
                marginTop: 8,
            },
        }
        createAccountButton = {
            ...createAccountButton,
            color: get(theme, "appicalTheme.contrastText"),
        }
        linkWidth = {
            ...linkWidth,
            color: get(theme, "appicalTheme.contrastText"),
        }
    }
    if (currentCompany === "legerdesheils") {
        simpleLink = {
            ...simpleLink,
            textDecoration: "none",
        }
    }
    return {
        mainContainer: {
            height: "100%",
        },

        mainContainerPrimary: {
            color: get(theme, "appicalTheme.loginBgText"),
        },

        mainContainerResetPassword: {
            color: get(theme, "appicalTheme.resetPasswordBgText"),
        },

        container: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            overflow: "auto",
        },

        navbar: {
            boxShadow: "none",
        },

        flex,
        loginBottom,

        createAccountButtonWrapper: {
            flex: "5",
        },
        accessibility: {
            ...linkWidth,
        },

        requestDataDeletion: {
            ...linkWidth,
        },

        createAccountButton,
        simpleLink,
        linkWidth,
    }
}

export default styles
